import { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip } from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

export default function AdminMonthlyBar({ projects = [], heightClass = "h-40" }) {
  const labels = useMemo(() => {
    const arr = [];
    const d = new Date();
    d.setDate(1);
    for (let i = 11; i >= 0; i -= 1) {
      const tmp = new Date(d);
      tmp.setMonth(d.getMonth() - i);
      arr.push(tmp.toLocaleString("en-US", { month: "short" }));
    }
    return arr;
  }, []);

  const dataPoints = useMemo(() => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setMonth(start.getMonth() - 11);
    start.setDate(1);

    const buckets = Array(12).fill(0);
    projects.forEach((row) => {
      const createdAt = row?.broker_intake?.created_at;
      if (!createdAt) return;
      const dt = new Date(createdAt);
      const diff =
        (dt.getFullYear() - start.getFullYear()) * 12 +
        (dt.getMonth() - start.getMonth());
      if (diff >= 0 && diff < 12) buckets[diff] += 1;
    });
    return buckets;
  }, [projects]);

  const chartData = {
    labels,
    datasets: [
      {
        data: dataPoints,
        borderWidth: 0,
        backgroundColor: "rgba(211,34,42,0.25)",
        hoverBackgroundColor: "rgba(211,34,42,0.5)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
      x: { grid: { display: false } },
    },
  };

  return (
    <div className={heightClass}>
      <Bar data={chartData} options={options} />
    </div>
  );
}
